<section>
  <div class="login-parent-div">
    <div class="login-image-div">
      <img
        [(src)]="env['logo_paths']['loginPagePic']"
        class="login-logo"
        alt="Login logo"
      />
    </div>
    <div class="login-form-div">
      <login-form></login-form>
      <p>
        Don't have an account.
        <a routerLink="/register" routerLinkActive="active">Register here</a>
      </p>
    </div>
  </div>
</section>
